import CodeFabrikGuiVue from 'codefabrik-gui-vue'
import { extend } from 'vee-validate'
import { email, min_value, required } from 'vee-validate/dist/rules'
import Vue from 'vue'
import i18n from './i18n'

extend('required', required)
extend('email', email)
extend('min_value', min_value)

const de = {
  messages: {
    required: '{_field_} wird benötigt.',
    email: 'E-Mail-Adresse hat das falsche Format.',
    min_value: 'Wert ist zu gering.'
  }
}

const en = {
  messages: {
    required: '{_field_} is required.',
    email: 'Email address has the wrong format',
    min_value: 'Value is too small.'
  }
}

Vue.use(CodeFabrikGuiVue, {
  listDataEmptyMessage: i18n._t(`common.noResults`, i18n.locale, i18n._getMessages(), i18n),
  locale: navigator.language,
  veeValidate: {
    dictionary: { de, en }
  }
})
